import { Marker, MarkerProps, Tooltip, } from 'react-leaflet'
import { SisetuPopup } from "./sisetuPopup"
import { activePin, inActivePin } from "features/sisetu/map/util"
import { SisetuResult } from "interface/sisetu"

type SisetuMarkerProps = {
  sisetu: SisetuResult
  active?: boolean
  openPopup?: boolean
  onOpen: (sisetuCode: string) => void
  onClose: () => void
} & Omit<MarkerProps, 'position' | 'icon'>
export const SisetuMarker = ({
  sisetu,
  active,
  openPopup,
  onOpen,
  onClose,
  ...others
}: SisetuMarkerProps) => (
  sisetu.location &&
  sisetu.location.latitude &&
  sisetu.location.longitude
) ? (
  <Marker
    {...others}
    ref={(marker) => {
      if (!marker) return
      if (openPopup) {
        window.setTimeout(() => marker.openPopup())
      } else {
        window.setTimeout(() => marker.closePopup())
      }
    }}
    position={[sisetu.location.latitude, sisetu.location.longitude]}
    icon={active ? activePin : inActivePin}
    zIndexOffset={active ? 99 : 1}
  >
    <Tooltip
      direction="top"
      className="tooltip"
      offset={active ? [0, -45] : [0, -20]}
      opacity={1}
    >
      {sisetu.sisetuName}
    </Tooltip>
    <SisetuPopup sisetuList={[sisetu]} onOpen={onOpen} onClose={onClose} />
  </Marker>
) : <></>
